import * as React from "react";
const SvgMore = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12,9.68A2.32,2.32,0,1,0,14.31,12,2.32,2.32,0,0,0,12,9.68Z" }), /* @__PURE__ */ React.createElement("path", { d: "M4.32,9.68A2.32,2.32,0,1,0,6.65,12,2.32,2.32,0,0,0,4.32,9.68Z" }), /* @__PURE__ */ React.createElement("path", { d: "M19.68,9.68A2.32,2.32,0,1,0,22,12h0a2.32,2.32,0,0,0-2.32-2.32Z" }));
export default SvgMore;
